import { Select, Tooltip } from "antd";
import React from "react";
import "./styles.scss";

export default ({
  header,
  disabled,
  clouds,
  buckets,

  selected_cloud_id,
  selected_bucket_id,

  on_bucket_change,
  on_cloud_change
}) => (
  <div className="bucket-selector">
    <header className="x-title">{header}</header>

    <div className="selection">
      <Select
        placeholder="destination"
        value={selected_cloud_id}
        onChange={e => on_cloud_change(e)}
        disabled={disabled}
        size={"large"}
        dropdownMatchSelectWidth={false}
        className={"cloud-select"}
        dropdownClassName="single-transfer-dropdown"
      >
        {clouds.map((f, index) => (
          <Select.Option key={index} value={f.id}>
            <Tooltip title={f.project_name}>{f.project_name}</Tooltip>
          </Select.Option>
        ))}
      </Select>

      <Select
        placeholder="Source bucket"
        showSearch={true}
        value={selected_bucket_id}
        onChange={e => on_bucket_change(e)}
        disabled={disabled}
        size={"large"}
        dropdownMatchSelectWidth={false}
        className={"transfer-select"}
        dropdownClassName="search-dropdown"
      >
        {buckets.map((f, index) => (
          <Select.Option key={index} value={f.id}>
            <Tooltip title={f.bucket_name}>{f.bucket_name}</Tooltip>
          </Select.Option>
        ))}
      </Select>
    </div>
  </div>
);
